"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _BSAggregator_blockchainServices;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BSAggregator = void 0;
const functions_1 = require("./functions");
class BSAggregator {
    constructor(blockchainServices) {
        _BSAggregator_blockchainServices.set(this, void 0);
        this.blockchainServicesByName = blockchainServices;
        __classPrivateFieldSet(this, _BSAggregator_blockchainServices, Object.values(blockchainServices), "f");
    }
    addBlockchain(name, blockchain) {
        if (this.blockchainServicesByName[name])
            throw new Error(`The blockchain ${name} already exist`);
        this.blockchainServicesByName[name] = blockchain;
        __classPrivateFieldGet(this, _BSAggregator_blockchainServices, "f").push(blockchain);
    }
    validateAddressAllBlockchains(address) {
        return __classPrivateFieldGet(this, _BSAggregator_blockchainServices, "f").some(bs => bs.validateAddress(address));
    }
    validateTextAllBlockchains(text) {
        return __classPrivateFieldGet(this, _BSAggregator_blockchainServices, "f").some(bs => [bs.validateAddress(text), bs.validateEncrypted(text), bs.validateKey(text)].some(it => it === true));
    }
    validateKeyAllBlockchains(wif) {
        return __classPrivateFieldGet(this, _BSAggregator_blockchainServices, "f").some(bs => bs.validateKey(wif));
    }
    validateEncryptedAllBlockchains(keyOrJson) {
        return __classPrivateFieldGet(this, _BSAggregator_blockchainServices, "f").some(bs => bs.validateEncrypted(keyOrJson));
    }
    getBlockchainNameByAddress(address) {
        return __classPrivateFieldGet(this, _BSAggregator_blockchainServices, "f").filter(bs => bs.validateAddress(address)).map(bs => bs.blockchainName);
    }
    getBlockchainNameByKey(wif) {
        return __classPrivateFieldGet(this, _BSAggregator_blockchainServices, "f").filter(bs => bs.validateKey(wif)).map(bs => bs.blockchainName);
    }
    getBlockchainNameByEncrypted(keyOrJson) {
        return __classPrivateFieldGet(this, _BSAggregator_blockchainServices, "f").filter(bs => bs.validateEncrypted(keyOrJson)).map(bs => bs.blockchainName);
    }
    generateAccountsFromMnemonic(mnemonic) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, functions_1.fetchAccountsForBlockchainServices)(__classPrivateFieldGet(this, _BSAggregator_blockchainServices, "f"), (service, index) => __awaiter(this, void 0, void 0, function* () {
                return service.generateAccountFromMnemonic(mnemonic, index);
            }));
        });
    }
}
exports.BSAggregator = BSAggregator;
_BSAggregator_blockchainServices = new WeakMap();
